import { render } from "./AddFournisseurPage.vue?vue&type=template&id=2cbf9d23&ts=true"
import script from "./AddFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./AddFournisseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__